module.exports = __webpack_public_path__ + "f8b0ad2f7730fa8ef9b024bae50e4f8d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-19.png
// module id = 2249
// module chunks = 0